export enum GenericActionTypes {
    SCAN_FOR_SEARCH = 'scan_for_search',
    CREATE_GROUP = 'create_group',
    ADD_TO_GROUP = 'add_to_group',
    SEE_LOCATION_HISTORY = 'see_location_history',
    SEE_STATUS_HISTORY = 'see_status_history',
    SET_DISCOUNT = 'set_discount',
}

export enum BalanceActionTypes {
    TOP_UP = 'top_up',
    GRANT_DISCOUNT = 'grant_discount',
    SEE_BALANCE_HISTORY = 'see_balance_history',
    SEE_BONUS_HISTORY = 'see_bonus_history',
}

// TODO: Combine actions in 1 enum

export enum InWarehouseActionTypes {
    MARK_AS_READY_FOR_SHIPMENT = 'mark_as_ready_for_shipment',
    SELECT_ORDERS_TO_LOCATE = 'select_orders_to_locate',
    SELECT_LOCATION_AND_ADD_ORDERS = 'select_location_and_add_orders',
    PRE_SELECT_LOCATION_AND_ADD_ORDERS = 'pre_select_location_and_add_orders',
    EXPORT = 'export_list',
    NOT_PREDEFINED = 'change_statuses',
    PRINT_BLANK = 'print_blank_for_warehouse',
    LOCATE = 'locate',
    CHANGE_STATUS = 'change_status',
    SEE_STATUS_HISTORY = 'see_status_history',
    ANNOUNCE = 'announce',
    READY_FOR_PICKUP = 'ready_for_pickup'
}

export enum ReadyForShipmentActionTypes {
    MARK_AS_SENT = 'mark_as_sent',
    SELECT_ORDERS_AND_ADD_TO_GROUP = 'select_orders_and_add_to_group',
    SELECT_GROUP_AND_ADD_ORDERS = 'select_group_and_add_orders',
    SELECT_GROUPS_OR_ORDERS_TO_LOCATE = 'select_groups_or_orders_to_locate',
    SELECT_LOCATION_AND_ADD_GROUPS_OR_ORDERS = 'select_location_and_add_groups_or_orders',
    CHANGE_GROUP_OR_ORDER_STATUSES = 'change_group_or_order_statuses',
    EXPORT_GROUPS_OR_ORDERS = 'export_groups_or_orders',
    REMOVE_ORDERS_FROM_A_GROUP = 'export_groups_or_orders',
    ADD_TO_GROUP = 'add_to_group',
    LOCATE = 'locate',
    CHANGE_STATUSES = 'change_statuses',
    CHANGE_STATUS = 'change_status',
    PRINT_BLANK = 'print_blank_for_warehouse',
}

export enum OrderPopupActionTypes {
    PRINT_BLANK = 'print_blank'
}

export enum BulkActionPopupActionTypes {
    REMOVE = 'remove'
}

export enum WarehouseManagementActionTypes {
    NEW_WAREHOUSE = 'new_warehouse',
    NEW_WAREHOUSE_WORKER = 'new_warehouse_worker',
}

export enum MessagesManagementActionTypes {
    NEW_MESSAGE = 'new_message',
    EDIT_MESSAGE = 'edit_message',
    DELETE_MESSAGE = 'delete_message',
}

export enum StaticDataActionTypes {
    NEW = 'new_static_data',
    EDIT = 'edit_static_data',
    DELETE = 'delete_static_data',
}
